import { useCallback } from "react";
import { isMobile } from "react-device-detect";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";

export interface uiStatusType {
  loggedSidebarCollapsed?: boolean;
  adminSidebarCollapsed?: boolean;
}

const uiStatusInitialValue: uiStatusType = {
  loggedSidebarCollapsed: isMobile ? true : false,
  adminSidebarCollapsed: isMobile ? true : false,
};

// The return value of makeVar is a function that you call to read or modify your reactive variable's value.
export const uiStatusVar: ReactiveVar<uiStatusType> =
  makeVar<uiStatusType>(uiStatusInitialValue);

export const clearUiStatus = () => {
  uiStatusVar(uiStatusInitialValue);
};

export const useUiStatus = () => {
  const uiStatusValue = useReactiveVar(uiStatusVar);

  const updateUiStatus = useCallback(
    (data: uiStatusType) => {
      uiStatusVar({
        ...uiStatusValue,
        ...data,
      });
    },
    [uiStatusValue]
  );

  return {
    uiStatusValue,
    updateUiStatus,
  };
};
